<template>
  <base-page-layout title="Resultados de encarte" use-new-filters :filters="['lojas', 'segmentos']">
    <v-container fluid class="ma-0 pa-0 resultados-encarte">
      <v-layout>
        <v-flex>
          <v-card class="px-4 pt-4 mb-4 primary-text">
            <p class="title">Encarte promocional</p>
            <p class="subheading">Produtos no encarte</p>
            <modal-graphql-search-content :selected-items.sync="produtosSelecionados" item-type="produto" />
            <v-divider class="mt-5 mb-4" />

            <p class="subheading mb-0">Período de validade do encarte</p>
            <v-container class="pa-0 ma-0" fill-height>
              <v-row>
                <v-col cols="3">
                  <mf-date-range-picker label="De - Até" :initial-date.sync="encarte.primeiraData" :final-date.sync="encarte.segundaData" :max="maxEncarte" />
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <mf-button :loading="generate.loading" label="Ver resultados" @click="generateData" />

          <v-card v-if="generate.show" class="my-3 pa-2 primary-text">
            <v-card-title>
              <span class="title">Resultados de Encarte</span>
            </v-card-title>
            <span class="mx-3">De {{ dataFormatada(encarte.primeiraData) }} Até {{ dataFormatada(encarte.segundaData) }}</span>
            <v-spacer />
            <span class="mx-3">({{ contagemDias }} dias)</span>
            <v-divider class="my-2" />
            <div class="gray-background pa-2 ma-2">
              <p class="mb-0 body-1">Produtos</p>
              <span v-for="(produto, index) in produtosSelecionados" :key="index" class="caption">
                <strong>{{ produto['COD_ID_PRODUTO_SEARCH'] || produto.sku }}</strong> - {{ produto['DES_PRODUTO_SEARCH'] || produto.name
                }}<span v-if="index < produtosSelecionados.length - 1">, </span>
              </span>
            </div>
            <div class="gray-background pa-2 ma-2">
              <p class="mb-0 body-1">Lojas</p>
              <span v-for="(loja, index) in lojasSelecionadas" :key="index" class="caption">
                <strong>{{ loja }}</strong
                ><span v-if="index < lojasSelecionadas.length - 1">, </span>
              </span>
              <span v-if="!lojasSelecionadas.length">-</span>
            </div>
            <div class="gray-background pa-2 ma-2">
              <p class="mb-0 body-1">Segmentos</p>
              <span v-for="(segmento, index) in segmentosSelecionados" :key="index" class="caption">
                <strong>{{ segmento }}</strong
                ><span v-if="index < segmentosSelecionados.length - 1">, </span>
              </span>
              <span v-if="!segmentosSelecionados.length">-</span>
            </div>
            <v-layout wrap>
              <v-flex xs12>
                <v-divider />
                <clientes-levados />
                <v-divider />
              </v-flex>
              <v-flex xs12>
                <faturamento />
                <v-divider />
              </v-flex>
              <v-flex xs12>
                <ticket-medio />
                <v-divider />
              </v-flex>
              <v-flex xs12>
                <produtos-fora-encarte />
                <v-divider />
              </v-flex>
              <v-flex xs12>
                <caca-ofertas />
              </v-flex>
            </v-layout>
          </v-card>

          <exportar-pdf v-if="generate.show" :produtos="produtosSelecionados" :primeiraData="encarte.primeiraData" :segundaData="encarte.segundaData" />
        </v-flex>
      </v-layout>
    </v-container>
  </base-page-layout>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import join from 'lodash/join'
import BasePageLayout from '@/components/BasePageLayout.vue'
import ClientesLevados from '@/modules/campanhas/resultados-encarte/views/pages/ClientesLevados.vue'
import ProdutosForaEncarte from '@/modules/campanhas/resultados-encarte/views/pages/ProdutosForaEncarte.vue'
import Faturamento from '@/modules/campanhas/resultados-encarte/views/pages/Faturamento.vue'
import CacaOfertas from '@/modules/campanhas/resultados-encarte/views/pages/CacaOfertas.vue'
import TicketMedio from '@/modules/campanhas/resultados-encarte/views/pages/TicketMedio.vue'
import ExportarPdf from '@/modules/campanhas/resultados-encarte/views/pages/ExportarPdf.vue'
import ModalGraphqlSearchContent from '@/components/ModalGraphqlSearchContent.vue'
import { mapActions, mapState } from 'vuex'
import { buscaProduto } from '@/services/kpis.js'
import { DateTime } from 'luxon'

export default {
  components: {
    BasePageLayout,
    ProdutosForaEncarte,
    ClientesLevados,
    Faturamento,
    CacaOfertas,
    TicketMedio,
    ExportarPdf,
    ModalGraphqlSearchContent,
  },
  data: () => ({
    loading: false,
    produtosSelecionados: [],
    produtos: [],
    searchProdutos: null,
    menu1: null,
    menu2: null,
    encarte: {
      primeiraData: '',
      segundaData: '',
    },
    generate: {
      loading: false,
      show: false,
    },
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
      lastUpdate: (state) => state.lastUpdate,
      allUnits: (state) => state.units.units,
    }),
    maxEncarte() {
      if (this.lastUpdate.last_updated) return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('yyyy-MM-dd')
      return ''
    },
    dateParam() {
      return [this.encarte.primeiraData, this.encarte.segundaData]
    },
    produtosParam() {
      const array = cloneDeep(this.produtosSelecionados).map((produto) => {
        return produto['COD_ID_PRODUTO_SEARCH'] || produto.sku
      })
      return join(array)
    },
    contagemDias() {
      const segData = DateTime.fromISO(this.encarte.segundaData)
      const primData = DateTime.fromISO(this.encarte.primeiraData)
      const diff = segData.diff(primData, ['days'])
      return diff.values.days
    },
    segmentosSelecionados() {
      if (!this.stateFilters.segmentsObjects?.length) {
        return []
      }
      return this.stateFilters.segmentsObjects.map((segment) => segment.name)
    },
    lojasSelecionadas() {
      return this.allUnits.filter((unit) => this.stateFilters.units.includes(unit.id_erp)).map((unit) => unit.name)
    },
  },
  watch: {
    searchProdutos(val) {
      val && this.querySelections(val)
    },
  },
  methods: {
    ...mapActions(['gerarEncarte']),
    querySelections(query) {
      this.loading = true
      const self = this
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        buscaProduto({ produto: query }).then((response) => {
          self.produtos = response.data
          this.loading = false
        })
      }, 500)
    },
    generateData() {
      const filter = {
        date: this.dateParam,
        unidades: this.stateFilters.unitsConfiguration,
        segmentos: this.stateFilters.segments,
        produtos: this.produtosParam.split(','),
      }

      this.generate.show = false
      this.generate.loading = true
      this.gerarEncarte(filter)
        .then((data) => {
          if (!data) {
            this.$snackbar({ message: 'Não há dados para essa composição' })
            this.generate.loading = false
          } else {
            this.generate.show = true
            this.generate.loading = false
          }
        })
        .catch(() => {
          this.$snackbar({ message: 'Ocorreu um erro, por favor tente novamente' })
          this.generate.loading = false
        })
    },
    dataFormatada(data) {
      return DateTime.fromFormat(data, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
    },
  },
}
</script>
<style lang="scss">
.resultados-encarte {
  .container {
    &.fill-height {
      height: 100px;
    }
  }
  .entre-datas {
    text-align: center;
    margin: 0;
  }
  .busca-produto {
    font-family: 'Lato', sans-serif;
    font-size: 18px;
    .dropdown-toggle {
      padding: 10px !important;
    }
    .clear {
      bottom: 16px !important;
    }
    .open-indicator {
      bottom: 15px !important;
    }
    .spinner {
      top: 15px !important;
    }
  }
  .gray-background {
    background-color: $cinza-l90;
    border-radius: 5px;
  }

  .initial-date {
    margin: 0 12px;
  }
}
</style>
